import type { ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { Login } from '../pages/Login';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { isLoggedIn } = useAuth();
  if (!isLoggedIn) return <Login />;
  return <>{children}</>;
}
